import CoursesRoutes from "@/pages/admin/components/course/router";
import UsersRoutes from "@/pages/admin/components/user/router";

export default [
	{
		path: 'user',
		component: () => import('@/pages/user/User'),
		meta: {
			requiresAuth: true,
		},
		children: [
			{
				path: 'password',
				name: 'UserPassword',
				component: () => import('@/pages/user/components/UserPassword'),
			},
		]
	},
];
